import React from 'react';

import { Heading, Caption } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

type Props = {
  value: number;
  text: string;
  withDivider?: boolean;
};

export function ShopDropCountdownItem({ value, text, withDivider }: Props) {
  return (
    <div
      className={clsx(styles.item, {
        [styles.withDivider]: withDivider,
      })}
    >
      <Heading variant="md">{value}</Heading>
      <Caption variant="lg-regular" className={styles.text}>
        {text}
      </Caption>
    </div>
  );
}
